import RegisterForm from "@components/features/customer/RegisterForm";
import TabSelect from "@components/features/customer/TabSelect";
import Auth from "@components/layouts/auth/Auth";
import withAuth from "@components/layouts/auth/WithAuth";
import SocialLoginProviders from "@components/features/customer/SocialLoginProviders";
import { getProviders } from "next-auth/react";

type Props = {};
const CustomerReigsterPage = (props: Props) => {
  return (
    <Auth>
      <div className="form">
        <TabSelect />
        <RegisterForm />
        <SocialLoginProviders providers={props} />
      </div>
    </Auth>
  );
};

export default withAuth(CustomerReigsterPage);

export async function getServerSideProps() {
  const providers = await getProviders();
  return {
    props: { providers },
  };
}
